
import { defineComponent, PropType } from 'vue'
import { RouteLocationRaw } from 'vue-router'
import NavbarItemContent from './NavbarItemContent.vue'

export default defineComponent({
  name: 'InternalLink',
  components: {
    NavbarItemContent
  },
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    },
    to: {
      type: Object as PropType<RouteLocationRaw>,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  setup () {
    return {}
  }
})
